import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CoreRouteReuseStrategy implements RouteReuseStrategy {

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {}

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (!!future.data['animation'] && future.component === curr.component) {
      return false; // Force re-creation to trigger animations
    }

    return future.routeConfig === curr.routeConfig;
  }
}

export const provideCoreRouteReuseStrategy = () => (
  {
    provide: RouteReuseStrategy,
    useClass: CoreRouteReuseStrategy,
  }
);
